import React from "react";

/** Main Page Function*/
function Home() {
  return (
    <div className="container">
      <h1>Home page</h1>
      <p>This page is on another project which uses Astro</p>
    </div>
  );
}

export default Home;
